import * as React from 'react';

const SvgDocument = (props) => (
  <svg
    width={24}
    height={24}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.5 10.19h-2.89c-2.37 0-4.3-1.93-4.3-4.3V3c0-.55-.45-1-1-1H8.07C4.99 2 2.5 4 2.5 7.57v8.86C2.5 20 4.99 22 8.07 22h7.86c3.08 0 5.57-2 5.57-5.57v-5.24c0-.55-.45-1-1-1Z'
      fill='#5C5C5C'
    />
    <path
      d='M15.8 2.21c-.41-.41-1.12-.13-1.12.44v3.49c0 1.46 1.24 2.67 2.75 2.67.95.01 2.27.01 3.4.01.57 0 .87-.67.47-1.07-1.44-1.45-4.02-4.06-5.5-5.54Z'
      fill='#5C5C5C'
    />
    <path
      d='M6.756 15.254c.519 0 .875-.18.875-.702 0-.627-.464-.656-1.022-.656h-.502v1.358h.65Zm1.958-.702c0 1.172-.952 1.59-1.942 1.59h-.665V18H5v-5h1.85c1.237 0 1.864.582 1.864 1.552ZM10.542 17.18h.519c.967 0 1.625-.314 1.625-1.68 0-1.306-.58-1.68-1.587-1.68h-.557v3.36ZM9.436 13h1.849c1.772 0 2.523 1.037 2.523 2.5 0 1.657-.983 2.5-2.678 2.5H9.436v-5ZM15.764 14.978h1.78v.895h-1.78V18h-1.107v-5H18v.896h-2.236v1.082Z'
      fill='#F4F4F4'
    />
  </svg>
);

export default SvgDocument;
